import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageHeaderComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @HostBinding('class.wai-page-header') public className = true;
}
